export default `
  fragment CountryFragment on countries {
    id
    name
  }
`;
